/* Cart drawer — AJAX add-to-cart, slide-out drawer, quantity + remove.
   Uses the Section Rendering API to keep server-side money formatting. */
(function () {
  var SECTION = 'cart-drawer';

  function drawer() { return document.querySelector('.cart-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (d) {
      // Flush layout so the panel's closed position (translateX(100%)) is
      // committed before we add .is-open — otherwise the slide-in is skipped
      // when the drawer was just re-rendered.
      var panel = d.querySelector('.cart-drawer__panel');
      if (panel) void panel.offsetWidth;
      d.classList.add('is-open');
    }
    document.documentElement.classList.add('cart-open');
  }
  function closeDrawer() {
    var d = drawer();
    if (d) d.classList.remove('is-open');
    document.documentElement.classList.remove('cart-open');
  }

  // Replace the drawer's inner markup with freshly rendered HTML.
  function swapDrawer(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('.cart-drawer');
    var existing = drawer();
    if (fresh && existing) {
      existing.innerHTML = fresh.innerHTML;
      syncHeaderCount();
    }
  }

  // Read the count from the drawer title ("Cart • N") and mirror it in the header.
  function syncHeaderCount() {
    var title = document.querySelector('.cart-drawer__title');
    var badge = document.querySelector('[data-cart-count]');
    if (!title || !badge) return;
    var m = title.textContent.match(/(\d+)/);
    var n = m ? m[1] : '0';
    badge.textContent = n;
    if (n === '0') badge.setAttribute('hidden', ''); else badge.removeAttribute('hidden');
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return postJSON('/cart/change.js', {
      line: line,
      quantity: quantity,
      sections: [SECTION],
      sections_url: window.location.pathname
    }).then(function (res) {
      if (res && res.sections && res.sections[SECTION]) swapDrawer(res.sections[SECTION]);
    });
  }

  // Intercept every add-to-cart form submission.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.tagName === 'FORM' && /\/cart\/add/.test(form.getAttribute('action') || ''))) return;
    // On the full cart page ("Something to consider" row) let the normal form
    // post run: Shopify adds the item and redirects back to /cart, so the page
    // itself refreshes. Adding via AJAX here only opened the drawer over a
    // stale page, which looked like the Add button did nothing.
    if (form.closest('.cartpg')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var data = new FormData(form);
    data.append('sections', SECTION);
    data.append('sections_url', window.location.pathname);

    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) return; // sold out / error — leave page as is
        if (res.sections && res.sections[SECTION]) swapDrawer(res.sections[SECTION]);
        openDrawer();
      })
      .catch(function () { form.submit(); }) // fallback to normal submit if AJAX fails
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  // Delegated clicks: open/close, quantity, remove.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-remove]');

    if (minus || plus || remove) {
      var li = e.target.closest('[data-line]');
      if (!li) return;
      var line = li.getAttribute('data-line');
      var val = parseInt((li.querySelector('.cart-item__qty-val') || {}).textContent, 10) || 1;
      if (remove) changeLine(line, 0);
      else if (plus) changeLine(line, val + 1);
      else if (minus) changeLine(line, Math.max(0, val - 1));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
